module.exports = __webpack_public_path__ + "img/mdi_instagram.f2fba8b9.png";